import React from "react";

import Api from "js/core/api";
import { withFirebaseUser } from "js/react/views/Auth/FirebaseUserContext";
import getLogger, { LogGroup } from "js/core/logger";

const logger = getLogger(LogGroup.APP);

export const Experiment = withFirebaseUser(class ExperimentImpl extends React.Component {
    state = {
        loading: true
    };

    async componentDidMount() {
        try {
            // API call will enroll user in experiment on-the-fly if necessary
            const res = await Api.experiments.post({ id: this.props.id });
            this.setState({ loading: false, enabled: res.enabled });
        } catch (err) {
            // failsafe
            logger.error(err, "[Experiment] componentDidMount() failed");
            this.setState({ loading: false, enabled: false });
        }
    }

    render() {
        if (this.state.loading) {
            return null;
        } else {
            return this.props.children(this.state.enabled);
        }
    }
});
